import { apiClient } from "helpers/api_helper"
import { API_ITEM_MASTER } from "../constants";

export const getItemMasterDropDown = async () => {
    try {
        const response = await apiClient.get(API_ITEM_MASTER.GET_ITEM_MASTER_DROPDOWN);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const getSubCategoryByCategoryId = async (categoryId: string) => {
    const res = await apiClient.get(
        `${API_ITEM_MASTER.GET_SUB_CATEGORY_BY_CATEGORY_ID}?categoryId=${categoryId}`
    );
    return res.data;
};

export const createItems = async (data: object) => {
    try {
        const res = await apiClient.post(API_ITEM_MASTER.CREATE_ITEM_MASTER, data);
        return res;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const getItemMasterDetailsByHeaderId = async (headerId: number) => {
    const res = await apiClient.get(
        `${API_ITEM_MASTER.GET_ITEM_MASTER_DETAILS}?headerId=${headerId}`
    );
    return res;
};

export const getItemMasterList = async (params: object) => {
    try {
        const response = await apiClient.get(API_ITEM_MASTER.GET_ITEM_MASTER_LIST, params);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};
